import React from "react";
import {View} from "react-native";
import ScreenTemplate from "./ScreenTemplate";
import styles from "./screen-styles";
import PtTicketsTrackingPage from "../components/tickets-tracking/pt-tickets-tracking-page";
import {isFeatureAvailable} from "../helpers/isFeatureAvailable";

/** set this to styles.withBoundaries to display borders around container views to visually debug layout overflows */
const showBoundaries = null;

export default function TicketsTrackingScreen({navigation, route}:any) {

  return (
    <ScreenTemplate navigation={navigation} route={route}>

      <View style={[styles.pageContentSlotContainer, showBoundaries]}>
        {isFeatureAvailable('ticketsTracking') ?
          <PtTicketsTrackingPage/>
          : null
        }
      </View>

    </ScreenTemplate>
  )

}
